import { Menu } from 'react-admin'

import SmartToy from '@mui/icons-material/SmartToy'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import Info from '@mui/icons-material/Info'

export const MyMenu = () => (
  <Menu>
    <Menu.DashboardItem />
    <Menu.Item to="/bots" primaryText="Bots" leftIcon={<SmartToy />} />
    <Menu.Item to="/charges" primaryText="Cobranças" leftIcon={<RequestQuoteIcon />} />
    <Menu.Item
      to="#"
      primaryText="Documentação"
      leftIcon={<Info />}
      onClick={() => {
        window.open('http://wiki.connectm.com.br', '_blank')
      }}
    />
  </Menu>
)
